<a (click)="backtoTheList()">
    <p>back to the list</p>
</a>
<h2 class="global-title">
    Edit pre confirmation template
</h2>
<div *ngIf="selectedTemplate" [formGroup]="templateForm" class="template-form">
    <p>Template before price table</p>
    <textarea formControlName="beforePriceTable" cols="30" rows="16"></textarea>
    <p>Template after price table</p>
    <textarea formControlName="afterPriceTable" cols="30" rows="18"></textarea>
    <p-button label="Submit" (onClick)="updateTemplate()"></p-button>
</div>